import {
  Breadcrumb,
  Checkbox,
  Input,
  message,
  Radio,
  Select,
  Tabs,
  Timeline,
} from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActiveDotIcon,
  BackIcon,
  ChevronDown,
  ChevronUp,
  CloseIcon,
  InactiveDotIcon,
} from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import style from "./RoleDetail.module.css";
import axios from "axios";
import { ROUTES } from "../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import Accordion from "../../../component/accordion/Accordion";
import { doGet, doPost } from "./RoleService";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import Delete from "../../../component/modal/ModalDelete";
import { useSelector } from "react-redux";
import { GROLOG_BASE_URL } from "../../../constant/apiConstant";
import moment from "moment";
import CustomDivider from "../../../component/divider/CustomDivider";

const RoleDetail = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [index, setIndex] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [parentMenu, setParentMenu] = useState([]);
  const [serviceMenu, setServiceMenu] = useState([]);
  const [itemMenu, setItemMenu] = useState([]);
  const [indexService, setIndexService] = useState();
  const [isOpenService, setIsOpenService] = useState();
  const [showDelete, setShowDelete] = useState(false);

  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);

  console.log("creates", location);
  const level1 = ["order", "master"];
  useEffect(() => {
    fetchData();
    getParent();
    getManagementHistoryList();
  }, []);

  const doGetBaseUrl = async (
    endpoint,
    tkn,
    params,
    dispatch,
    refresh_token
  ) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(
      `audit/v1/grolog/audit?page=1&filter=table_name eq role, primary_key eq ${location.state.id}`
    );

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data?.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element);
    }

    setManagementHistoryList(reorderedData);
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthNumbers = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return `${dateFormat.getDate()}-${
        monthNames[dateFormat.getMonth()]
      }-${dateFormat.getFullYear()}`;
    } else {
      return `${dateFormat.getDate()}/${
        monthNumbers[dateFormat.getMonth()]
      }/${dateFormat.getFullYear()}`;
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };

  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const getParent = async () => {
    let sub = {
      id: location.state.id,
    };
    let res = await doPost(`/role/parentmenu?${param}`, token, sub);
    setParentMenu(res.data.payload.data);
  };

  const fetchData = async () => {
    let res = await doGet(`/role/${location.state.id}?${param}`, token);
    setDetail(res?.data?.payload?.data);
  };

  const clickCard = async (i, id) => {
    if (isOpenService) {
      setServiceMenu("");
      setItemMenu("");
      setIndex("");
      setIsOpen(false);
      setIndexService("");
      setIsOpenService(false);
    } else {
      let sub = {
        permission_condition: "insert",
        menu_parent_id: id,
      };
      let res = await doPost(`/role/servicemenu?${param}`, token, sub);
      setServiceMenu(res.data.payload.data);
      setIndex(i);
      setIsOpen(isOpen ? false : true);
    }
  };

  const clickCardService = async (i, idParent, idService) => {
    let sub = {
      permission_condition: "insert",
      menu_parent_id: idParent,
      service_menu_id: idService,
    };
    let res = await doPost(`/role/itemmenu?${param}`, token, sub);
    setItemMenu(res.data.payload.data);
    setIndexService(i);
    setIsOpenService(isOpenService ? false : true);
  };

  const setClear = () => {
    setServiceMenu("");
    setItemMenu("");
    setIndex("");
    setIsOpen(false);
    setIndexService("");
    setIsOpenService(false);
  };

  const Detail = () => {
    return (
      <>
        <CustomDivider name={"User Information"} />
        <div className="flex">
          <div>
            <div className="flex">
              <div className="gap-[40px] mb-[24px]">
                {/* <div className="w-[500px] mb-[24px]"> */}
                {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-2">
                    {t("User Information")}
                  </h3> */}

                {/* </div> */}

                {/* //one */}
                <div className="gap-[40px] mb-[24px]">
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("ID")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Role")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Description")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.description}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Level")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.level}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Permission = () => {
    return (
      <>
        {/* <div className="w-[500px] mb-[24px] ml-5"> */}
        {/* <h3 className="font-roboto text-[18px] mb-6 mt-2 font-medium">
            {t("Permission Information")}
          </h3> */}
        <CustomDivider name={"Permission Information"} />
        {/* </div> */}
        {parentMenu.map((el, i) => {
          return (
            <>
              {
              el.code !== "monitoring" ? (
                <div>
                  <Accordion
                    address={"Level 1 - " + el.name}
                    onClick={() => clickCard(i, el.id)}
                    index={i}
                    i={index}
                    isOpen={isOpen}
                    // address={el.address}
                    body={
                      <>
                        {isOpen === true && i === index ? (
                          <>
                            <div className="flex ml-9 font-medium">
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  className="mr-2"
                                  checked={
                                    detail.role_permission?.findIndex(
                                      (i) => i === el.code + ":view"
                                    ) >= 0
                                  }
                                  //  checked={dataSent?.find(
                                  //    (permission) => permission === el.code + ":view"
                                  //  )}
                                  disabled
                                  //  onChange={(event) =>
                                  //    onChecked(event, el.code, "view")
                                  //  }
                                />
                                View
                              </div>
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  disabled
                                  className="mr-2"
                                  checked={
                                    detail.role_permission?.findIndex(
                                      (i) => i === el.code + ":insert"
                                    ) >= 0
                                  }
                                  //  checked={dataSent?.find(
                                  //    (permission) => permission === el.code + ":insert"
                                  //  )}
                                  //  onChange={(event) =>
                                  //    onChecked(event, el.code, "insert")
                                  //  }
                                />
                                Insert
                              </div>
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  disabled
                                  className="mr-2"
                                  checked={
                                    detail.role_permission?.findIndex(
                                      (i) => i === el.code + ":update"
                                    ) >= 0
                                  }
                                  //  checked={dataSent?.find(
                                  //    (permission) => permission === el.code + ":update"
                                  //  )}
                                  //  onChange={(event) =>
                                  //    onChecked(event, el.code, "update")
                                  //  }
                                />
                                Update
                              </div>
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  disabled
                                  className="mr-2"
                                  checked={
                                    detail.role_permission?.findIndex(
                                      (i) => i === el.code + ":delete"
                                    ) >= 0
                                  }
                                />
                                Delete
                              </div>
                            </div>
                            <div>
                              {serviceMenu?.map((menu, i) => {
                                return (
                                  <>
                                  {menu.code  ?
              <>
                                    <div className="ml-10 pb-10">
                                      <div className="flex justify-between pt-[10px] pr-10 pb[10px] w-full">
                                        <div className="color-black font-medium mt-[10px] text-left text-2xl">
                                          Level 2 - {menu.name}
                                        </div>
                                        {
                                          menu.code === "order.shippingcostpayment" || menu.code === "order.invoice"|| menu.code === "report.logreport"
                                          ? <></>
                                          :
                                          <>
                                        <div
                                          // onClick={props.child}
                                          className="cursor-pointer ml-[40px] mt-[25px]"
                                          onClick={() =>
                                            clickCardService(i, el.id, menu.id)
                                          }
                                        >
                                          {isOpenService &&
                                          i === indexService ? (
                                            <img
                                              src={ChevronDown}
                                              alt="arrowUp"
                                            />
                                          ) : (
                                            <img
                                              src={ChevronUp}
                                              alt="arrowDown"
                                            />
                                          )}
                                        </div>
                                        </>
                              }
                                      </div>
                                      {/* permission service */}
                                      <div className="flex font-medium">
                                        <div className={"m-2"}>
                                          <div className="mt-4">View</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              disabled
                                              //onChange={(e)=>onRadio(e, menu.code)}
                                              defaultValue={
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":view"
                                                ) >= 0 ||
                                                detail.role_permission?.findIndex(
                                                  (i) => i === el.code + ":view"
                                                ) >= 0
                                                  ? "view"
                                                  : detail.role_permission?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code + ":view-own"
                                                    ) >= 0
                                                  ? "view-own"
                                                  : ""
                                              }
                                              className="flex"
                                            >
                                              <Radio value="view">All</Radio>
                                              <Radio value="view-own">
                                                View Own
                                              </Radio>
                                            </Radio.Group>
                                          </div>
                                        </div>

                                        <div className={"m-2"}>
                                          <div className="mt-4">Insert</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              disabled
                                              //onChange={(e)=>onRadio(e, menu.code)}
                                              // defaultValue="view"
                                              defaultValue={
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === el.code + ":insert"
                                                ) >= 0 ||
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":insert"
                                                ) >= 0
                                                  ? "insert"
                                                  : detail.role_permission?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code + ":insert"
                                                    ) >= 0
                                                  ? "insert-own"
                                                  : ""
                                              }
                                              className="flex"
                                            >
                                              <Radio value="insert">All</Radio>
                                              {/* <Radio value="insert-own">
                                            insert Own
                                          </Radio> */}
                                            </Radio.Group>
                                          </div>
                                        </div>

                                        <div className={"m-2"}>
                                          <div className="mt-4">Update</div>
                                          <div
                                            className={style.radio + " flex"}
                                          >
                                            <Radio.Group
                                              disabled
                                              defaultValue={
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === el.code + ":update"
                                                ) >= 0 ||
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":update"
                                                ) >= 0
                                                  ? "update"
                                                  : detail.role_permission?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code + ":update"
                                                    ) >= 0
                                                  ? "update-own"
                                                  : ""
                                              }
                                              //onChange={(e)=>onRadio(e, menu.code)}
                                              // defaultValue="Update"
                                              className="flex"
                                            >
                                              <Radio value="update">All</Radio>
                                              <Radio value="update-own">
                                                Update Own
                                              </Radio>
                                            </Radio.Group>
                                          </div>
                                        </div>

                                        <div className={"m-2"}>
                                          <div className="mt-4">Delete</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              disabled
                                              //onChange={(e)=>onRadio(e, menu.code)}
                                              defaultValue={
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === el.code + ":delete"
                                                ) >= 0 ||
                                                detail.role_permission?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":delete"
                                                ) >= 0
                                                  ? "delete"
                                                  : detail.role_permission?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code + ":delete"
                                                    ) >= 0
                                                  ? "delete-own"
                                                  : ""
                                              }
                                              className="flex"
                                            >
                                              <Radio value="delete">All</Radio>
                                              <Radio value="delete-own">
                                                Delete Own
                                              </Radio>
                                            </Radio.Group>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {isOpenService === true &&
                                    i === indexService ? (
                                      <>
                                        {itemMenu?.map((menus, i) => {
                                          return (
                                            <>
                                              <div className="ml-10 pb-10">
                                                <div className="flex justify-between pt-[10px] pr-10 pb[10px] w-full">
                                                  <div className="color-black font-medium mt-[10px] text-left text-2xl">
                                                    Level 3 - {menus.name}
                                                  </div>
                                                </div>
                                                {/* permission service */}
                                                <div className="flex font-medium">
                                                  <div className={"m-2"}>
                                                    <div className="mt-4">
                                                      View
                                                    </div>
                                                    <div
                                                      className={style.radio}
                                                    >
                                                      <Radio.Group
                                                        disabled
                                                        //onChange={(e)=>onRadio(e, menu.code)}
                                                        // defaultValue="view"
                                                        defaultValue={
                                                          detail.role_permission?.findIndex(
                                                            (i) =>
                                                              i ===
                                                              el.code + ":view"
                                                          ) >= 0 ||
                                                          detail.role_permission?.findIndex(
                                                            (i) =>
                                                              i ===
                                                              menus.code +
                                                                ":view"
                                                          ) >= 0
                                                            ? "view"
                                                            : detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":view"
                                                              ) >= 0
                                                            ? "view-own"
                                                            : ""
                                                        }
                                                        className="flex"
                                                      >
                                                        <Radio value="view">
                                                          All
                                                        </Radio>
                                                        <Radio value="view-own">
                                                          View Own
                                                        </Radio>
                                                      </Radio.Group>
                                                    </div>
                                                  </div>

                                                  {menus.code ===
                                                    "setup.profile.address" ||
                                                  menus.code ===
                                                    "setup.profile.company" ? (
                                                    <></>
                                                  ) : (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Insert
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="view"
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":insert"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":insert"
                                                              ) >= 0
                                                                ? "insert"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":insert"
                                                                  ) >= 0
                                                                ? "insert-own"
                                                                : ""
                                                            }
                                                            className="flex"
                                                          >
                                                            <Radio value="insert">
                                                              All
                                                            </Radio>
                                                            <Radio value="insert-own">
                                                              insert Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}

                                                  {menus.code ===
                                                    "order.routes.tripplanning" ||
                                                  menus.code ===
                                                    "order.request.request" ? (
                                                    <></>
                                                  ) : (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Update
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio +
                                                            " flex"
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":update"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":update"
                                                              ) >= 0
                                                                ? "update"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":update"
                                                                  ) >= 0
                                                                ? "update-own"
                                                                : ""
                                                            }
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="Update"
                                                            className="flex"
                                                          >
                                                            <Radio value="update">
                                                              All
                                                            </Radio>
                                                            <Radio value="update-own">
                                                              Update Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}

                                                  {menus.code ===
                                                    "order.routes.tripplanning" ||
                                                  menus.code ===
                                                    "order.routes.alltrip" ||
                                                  menus.code ===
                                                    "setup.profile.company" ||
                                                  menus.code ===
                                                    "setup.profile.address" ? (
                                                    <></>
                                                  ) : (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Delete
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="delete"
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":delete"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":delete"
                                                              ) >= 0
                                                                ? "delete"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":delete"
                                                                  ) >= 0
                                                                ? "delete-own"
                                                                : ""
                                                            }
                                                            className="flex"
                                                          >
                                                            <Radio value="delete">
                                                              All
                                                            </Radio>
                                                            <Radio value="delete-own">
                                                              Delete Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                                  {menus.code ===
                                                  "order.routes.tripplanning" ? (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Approve
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="delete"
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":approve"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":approve"
                                                              ) >= 0
                                                                ? "approve"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":approve"
                                                                  ) >= 0
                                                                ? "approve-own"
                                                                : ""
                                                            }
                                                            className="flex"
                                                          >
                                                            <Radio value="approve">
                                                              All
                                                            </Radio>
                                                            <Radio value="approve-own">
                                                              Approve Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Reject
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="delete"
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":reject"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":reject"
                                                              ) >= 0
                                                                ? "reject"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":reject"
                                                                  ) >= 0
                                                                ? "reject-own"
                                                                : ""
                                                            }
                                                            className="flex"
                                                          >
                                                            <Radio value="reject">
                                                              All
                                                            </Radio>
                                                            <Radio value="reject-own">
                                                              Reject Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : menus.code ===
                                                    "order.routes.alltrip" ? (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Start
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="delete"
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":start"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":start"
                                                              ) >= 0
                                                                ? "start"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":start"
                                                                  ) >= 0
                                                                ? "start-own"
                                                                : ""
                                                            }
                                                            className="flex"
                                                          >
                                                            <Radio value="start">
                                                              All
                                                            </Radio>
                                                            <Radio value="start-own">
                                                              Start Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          End
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            disabled
                                                            //onChange={(e)=>onRadio(e, menu.code)}
                                                            // defaultValue="delete"
                                                            defaultValue={
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  el.code +
                                                                    ":end"
                                                              ) >= 0 ||
                                                              detail.role_permission?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":end"
                                                              ) >= 0
                                                                ? "end"
                                                                : detail.role_permission?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":end"
                                                                  ) >= 0
                                                                ? "end-own"
                                                                : ""
                                                            }
                                                            className="flex"
                                                          >
                                                            <Radio value="end">
                                                              All
                                                            </Radio>
                                                            <Radio value="end-own">
                                                              End Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      () => setClear()
                                    )}
                                    </> : <></>}
                                  </>
                                );
                              })}
                            </div>
                          </>
                        ) : (
                          () => setClear()
                        )}
                      </>
                    }
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          );
        })}
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("Detail Role"),
      children: Detail(),
    },
    {
      key: 2,
      label: t("Set Permission"),
      children: Permission(),
    },
  ];

  return (
    <>
      <Delete
        data={detail.updated_at}
        id={detail.id}
        delete={showDelete}
        title={detail.role_id}
        url={"role"}
        action={() => setShowDelete(false)}
        route={ROUTES.ROLE.LIST}
        token={token}
        param={param}
        // refresh={fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Admin`}
          menuLevel2={`User Management`}
          menuLevel3={`Role`}
          menuLevel4={"Detail " + detail.role_id}
        />

        <div className="flex items-center justify-between">
          <div
            className="flex items-center gap-[22px] cursor-pointer"
            onClick={() => navigate(ROUTES.ROLE.LIST)}
          >
            <img src={BackIcon} alt="" />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail.role_id}
            </h1>
          </div>
          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong>
            </p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
          <aside
            className={
              userManagementOpen
                ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
                : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
            }
          >
            <button
              className="absolute top-[21px] right-[21px]"
              onClick={() => setUserManagementOpen(false)}
            >
              <img src={CloseIcon} alt="" />
            </button>

            <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
              {t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}
            </h3>
            <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at)}</strong>
            </p>

            <div className={style.timelineContainer}>
              <Timeline>
                {managementHistoryList.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                        <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                          <h4
                            className={"text-[#CF0000] font-[500] text-[14px]"}
                          >
                            {t("USER_DETAIL:LAST_MODIFIED")}
                          </h4>
                          <h4 className="font-[500] text-[14px] text-[#424242]">
                            {item.alias_name}
                          </h4>
                          <p className="font-[400] text-[14px]">{`${convertTimestamp(
                            item.created_at
                          )} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    );
                  } else {
                    return (
                      <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                        <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                          <h4 className={"font-[500]"}>
                            {t("USER_DETAIL:MODIFIED")}
                          </h4>
                          <h4 className="font-[500] text-[14px] text-[#424242]">
                            {item.alias_name}
                          </h4>
                          <p className="font-[400] text-[14px]">{`${convertTimestamp(
                            item.created_at
                          )} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    );
                  }
                })}
              </Timeline>
            </div>
          </aside>
        </div>
        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton
            disabled={location.state.created_by === "Y"}
            text={t("DRIVER:EDIT")}
            action={() => navigate(ROUTES.ROLE.EDIT, { state: detail.id })}
            actions="update"
            menu="role"
            parent="admin"
          />
          <SecondaryButton
            disabled={location.state.created_by === "Y"}
            text={t("DRIVER:DELETE")}
            action={() => setShowDelete(true)}
            actions="delete"
            menu="role"
            parent="admin"
          />
        </div>
      </div>
    </>
  );
};
export default RoleDetail;
